import { useOpMutation } from '../useOpMutation';

export const useUpdateUserPreferenceSet = ({ ...useOpMutationOptions } = {}) =>
  useOpMutation({
    apiEndpointName: 'updateUserPreferenceSet',
    queryKeysToInvalidate: [['describeUserPreferenceSet']],
    ...useOpMutationOptions,
  });
